export const formatCreditAmount = (amount: number): string => {
  if (amount >= 1000) {
    const suffixes = ['', 'K', 'M', 'B']
    let index = 0
    let num = amount

    while (num >= 1000 && index < suffixes.length - 1) {
      num /= 1000
      index++
    }

    return `${num % 1 === 0 ? num.toFixed(0) : num.toFixed(1)}${suffixes[index]}`
  }
  return amount.toString()
}

/**
 * Check if a number is a number
 * @param number - The number to check
 * @returns true if the number is a number (starts with 'VIRTUAL_'), false otherwise
 */
export const isNumber = (number: any): boolean => {
  if (!number) return true
  return isVirtualNumber(number)
}

export const isVirtualNumber = (number: string): boolean => {
  if (number && typeof number === 'string' && number.startsWith('VIRTUAL_')) return true
  return false
}
